export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "gemstones": "ರತ್ನಗಳು",
    "healing_crystal_guidance": "ಚಿಕಿತ್ಸಕ ಸ್ಫಟಿಕ ಮಾರ್ಗದರ್ಶನ",
    "gemstones_description": "ನಿಮ್ಮ ಅನನ್ಯ ಜನ್ಮ ಚಾರ್ಟ್‌ನ ಆಧಾರದ ಮೇಲೆ ವೈಯಕ್ತಿಕ ರತ್ನ ಮತ್ತು ಸ್ಫಟಿಕ ಶಿಫಾರಸುಗಳನ್ನು ಸ್ವೀಕರಿಸಿ. ಚಿಕಿತ್ಸೆ, ರಕ್ಷಣೆ, ಸಮೃದ್ಧಿ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆಗಾಗಿ ಪರಿಪೂರ್ಣ ರತ್ನಗಳನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ—ಅವುಗಳ ಪ್ರಯೋಜನಗಳನ್ನು ಗರಿಷ್ಠಗೊಳಿಸಲು ಅವುಗಳನ್ನು ಆರಿಸುವುದು, ಧರಿಸುವುದು ಮತ್ತು ಆರೈಕೆ ಮಾಡುವ ಬಗ್ಗೆ ತಜ್ಞ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ.",

    "gemstone_power": "ರತ್ನ ಶಕ್ತಿ",
    "unlock_your": "ನಿಮ್ಮ",

    // Service Information
    "enter_details_for_gemstone_analysis": "ರತ್ನ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_gemstone_analysis": "ಸಂಪೂರ್ಣ ರತ್ನ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_gemstone_analysis_note": "ಗ್ರಹಗಳ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಧರಿಸುವ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ವೈಯಕ್ತಿಕ ರತ್ನ ಶಿಫಾರಸುಗಳು",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_gemstone_resonance": "ನಿಮ್ಮ ಹೆಸರಿನ ಕಂಪನಗಳು ರತ್ನ ಪ್ರತಿಧ್ವನಿ ಮತ್ತು ಹೊಂದಾಣಿಕೆಯನ್ನು ನಿರ್ಧರಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತವೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_planetary_gemstones": "ಗ್ರಹಗಳ ಪ್ರಭಾವಗಳು ಮತ್ತು ಸೂಕ್ತ ರತ್ನಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಅಗತ್ಯವಾದುದು",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_gemstone_selection": "ನಿಖರವಾದ ಗ್ರಹ ಬಲ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_affects_gemstone_energy": "ಸ್ಥಳವು ರತ್ನ ಆಯ್ಕೆಯ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುವ ಗ್ರಹಗಳ ಸ್ಥಾನಗಳನ್ನು ಪ್ರಭಾವಿಸುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ರತ್ನ ಮಾರ್ಗದರ್ಶಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core Gemstone Features
    "personalized_gemstone_recommendations": "ವೈಯಕ್ತಿಕ ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "planetary_gemstone_analysis": "ಗ್ರಹಗಳ ರತ್ನ ವಿಶ್ಲೇಷಣೆ",
    "healing_crystal_guidance": "ಚಿಕಿತ್ಸಕ ಸ್ಫಟಿಕ ಮಾರ್ಗದರ್ಶನ",
    "wearing_methods_timing": "ಧರಿಸುವ ವಿಧಾನಗಳು ಮತ್ತು ಸಮಯ",
    "gemstone_care_instructions": "ರತ್ನ ಆರೈಕೆ ಸೂಚನೆಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ಮಾರ್ಗದರ್ಶಿ",

    "what_you_get": "ನಿಮ್ಮ ರತ್ನ ವಿಶ್ಲೇಷಣೆಯು ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "personalized_gemstone_guide": "ವೈಯಕ್ತಿಕ ರತ್ನ ಮಾರ್ಗದರ್ಶಿ",
    "planetary_remedial_stones": "ಗ್ರಹಗಳ ಪರಿಹಾರ ರತ್ನಗಳು",
    "healing_crystal_recommendations": "ಚಿಕಿತ್ಸಕ ಸ್ಫಟಿಕ ಶಿಫಾರಸುಗಳು",
    "wearing_activation_guidance": "ಧರಿಸುವ ಮತ್ತು ಸಕ್ರಿಯಗೊಳಿಸುವ ಮಾರ್ಗದರ್ಶನ",

    // Actions & Buttons
    "pay_and_get_gemstone_guidance": "ನನ್ನ ರತ್ನ ಮಾರ್ಗದರ್ಶಿಯನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ಮಾರ್ಗದರ್ಶಿಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "gemstone_analysis_processing": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ರತ್ನ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ರತ್ನಶಾಸ್ತ್ರಜ್ಞರು ಮತ್ತು ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನೀವು ಚಿಕಿತ್ಸಕ ಮತ್ತು ಪರಿಹಾರ ರತ್ನಗಳ ವಿಸ್ತೃತ ಶಿಫಾರಸುಗಳನ್ನು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ಮಾರ್ಗದರ್ಶಿ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ರತ್ನ ಮಾರ್ಗದರ್ಶಿ 12 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ಮಾರ್ಗದರ್ಶಿಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ರತ್ನ ಮಾರ್ಗದರ್ಶಿ ಪ್ಯಾಕೇಜ್",
    "detailed_gemstone_report_pdf": "ವಿಸ್ತೃತ ರತ್ನ ವರದಿ (PDF)",
    "personalized_stone_recommendations": "ವೈಯಕ್ತಿಕ ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "planetary_remedial_guidance": "ಗ್ರಹಗಳ ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನ",
    "wearing_activation_methods": "ಧರಿಸುವ ಮತ್ತು ಸಕ್ರಿಯಗೊಳಿಸುವ ವಿಧಾನಗಳು",
    "gemstone_care_maintenance": "ರತ್ನ ಆರೈಕೆ ಮತ್ತು ನಿರ್ವಹಣೆ",

    // Visual Content
    "sample_gemstone_analysis": "ಮಾದರಿ ರತ್ನ ವಿಶ್ಲೇಷಣೆ",
    "recommended_gemstone": "ಶಿಫಾರಸು ಮಾಡಿದ ರತ್ನ",
    "sample_gemstone_reading": "ಶನಿ ಬಲೀಕರಣ ಮತ್ತು ಬುದ್ಧಿವಂತಿಕೆ ವರ್ಧನೆಗಾಗಿ ನೀಲ ರತ್ನ",
    "sample_gemstone_preview": "ಚಿಕಿತ್ಸಕ ಗುಣಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ರತ್ನ ಶಿಫಾರಸುಗಳ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "gemstone_categories": "ರತ್ನ ವರ್ಗಗಳು",

    // Gemstone Types
    "ruby": "ಮಾಣಿಕ್ಯ",
    "emerald": "ಪಚ್ಚೆ",
    "sapphire": "ನೀಲ ರತ್ನ",
    "diamond": "ವಜ್ರ",
    "yellow_sapphire": "ಹಳದಿ ರತ್ನ",
    "coral": "ಹವಳ",

    // Status & Processing
    "your_gemstone_analysis_status": "ನಿಮ್ಮ ರತ್ನ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ರತ್ನ ಅಗತ್ಯತೆಗಳನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ತಜ್ಞ ರತ್ನಶಾಸ್ತ್ರಜ್ಞರು ಚಿಕಿತ್ಸೆ, ರಕ್ಷಣೆ ಮತ್ತು ಸಮೃದ್ಧಿಗಾಗಿ ಅತ್ಯಂತ ಸೂಕ್ತವಾದ ರತ್ನಗಳನ್ನು ಶಿಫಾರಸು ಮಾಡಲು ನಿಮ್ಮ ಜನ್ಮ ಚಾರ್ಟ್ ಅನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "12 ಗಂಟೆಗಳೊಳಗೆ ಮಾರ್ಗದರ್ಶಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ರತ್ನ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Planetary Gemstones
    "sun_gemstones": "ಸೂರ್ಯ ರತ್ನಗಳು",
    "moon_gemstones": "ಚಂದ್ರ ರತ್ನಗಳು",
    "mars_gemstones": "ಮಂಗಳ ರತ್ನಗಳು",
    "mercury_gemstones": "ಬುಧ ರತ್ನಗಳು",
    "jupiter_gemstones": "ಗುರು ರತ್ನಗಳು",
    "venus_gemstones": "ಶುಕ್ರ ರತ್ನಗಳು",
    "saturn_gemstones": "ಶನಿ ರತ್ನಗಳು",
    "rahu_gemstones": "ರಾಹು ರತ್ನಗಳು",
    "ketu_gemstones": "ಕೇತು ರತ್ನಗಳು",

    // Primary Gemstones
    "ruby_manik": "ಮಾಣಿಕ್ಯ (ಮಾಣಿಕ್)",
    "pearl_moti": "ಮುತ್ತು (ಮೋತಿ)",
    "coral_moonga": "ಕೆಂಪು ಹವಳ (ಮೂಂಗ)",
    "emerald_panna": "ಪಚ್ಚೆ (ಪನ್ನ)",
    "yellow_sapphire_pukhraj": "ಹಳದಿ ರತ್ನ (ಪುಖ್ರಾಜ್)",
    "diamond_heera": "ವಜ್ರ (ಹೀರಾ)",
    "blue_sapphire_neelam": "ನೀಲ ರತ್ನ (ನೀಲಮ್)",
    "hessonite_gomed": "ಹೆಸ್ಸೊನೈಟ್ (ಗೋಮೇದ್)",
    "cats_eye_lehsunia": "ಬೆಕ್ಕಿನ ಕಣ್ಣು (ಲೆಹ್ಸುನಿಯ)",

    // Secondary Gemstones
    "garnet": "ಗಾರ್ನೆಟ್",
    "moonstone": "ಚಂದ್ರಕಾಂತ",
    "carnelian": "ಕಾರ್ನೆಲಿಯನ್",
    "peridot": "ಪೆರಿಡಾಟ್",
    "citrine": "ಸಿಟ್ರಿನ್",
    "opal": "ಓಪಲ್",
    "amethyst": "ಅಮೆಥಿಸ್ಟ್",
    "agate": "ಅಗೇಟ್",
    "onyx": "ಓನಿಕ್ಸ್",

    // Healing Crystals
    "rose_quartz": "ರೋಸ್ ಕ್ವಾರ್ಟ್ಜ್",
    "clear_quartz": "ಕ್ಲಿಯರ್ ಕ್ವಾರ್ಟ್ಜ್",
    "amethyst_crystal": "ಅಮೆಥಿಸ್ಟ್ ಸ್ಫಟಿಕ",
    "citrine_crystal": "ಸಿಟ್ರಿನ್ ಸ್ಫಟಿಕ",
    "black_tourmaline": "ಕಪ್ಪು ಟೂರ್ಮಲೈನ್",
    "green_aventurine": "ಹಸಿರು ಅವೆಂಚುರಿನ್",
    "tigers_eye": "ಹುಲಿಯ ಕಣ್ಣು",
    "labradorite": "ಲ್ಯಾಬ್ರಡೋರೈಟ್",
    "fluorite": "ಫ್ಲೂರೈಟ್",

    // Gemstone Properties
    "healing_properties": "ಚಿಕಿತ್ಸಕ ಗುಣಗಳು",
    "protective_properties": "ರಕ್ಷಣಾತ್ಮಕ ಗುಣಗಳು",
    "prosperity_properties": "ಸಮೃದ್ಧಿ ಗುಣಗಳು",
    "spiritual_properties": "ಆಧ್ಯಾತ್ಮಿಕ ಗುಣಗಳು",
    "emotional_properties": "ಭಾವನಾತ್ಮಕ ಚಿಕಿತ್ಸಕ ಗುಣಗಳು",
    "physical_properties": "ಭೌತಿಕ ಚಿಕಿತ್ಸಕ ಗುಣಗಳು",

    // Gemstone Selection Criteria
    "planetary_strength": "ಗ್ರಹಗಳ ಬಲ ವಿಶ್ಲೇಷಣೆ",
    "weak_planets": "ದುರ್ಬಲ ಗ್ರಹಗಳ ಗುರುತಿಸುವಿಕೆ",
    "malefic_planets": "ಅಶುಭ ಗ್ರಹಗಳ ವಿಶ್ಲೇಷಣೆ",
    "benefic_enhancement": "ಶುಭ ಗ್ರಹ ವರ್ಧನೆ",
    "doshas_correction": "ದೋಷಗಳ ತಿದ್ದುಪಡಿ",
    "yogas_strengthening": "ಯೋಗಗಳ ಬಲೀಕರಣ",

    // Quality & Authenticity
    "gemstone_quality": "ರತ್ನ ಗುಣಮಟ್ಟದ ಮಾರ್ಗಸೂಚಿಗಳು",
    "authenticity_check": "ಅಧಿಕೃತತೆ ಪರಿಶೀಲನೆ",
    "certification_importance": "ಪ್ರಮಾಣೀಕರಣದ ಮಹತ್ವ",
    "natural_vs_synthetic": "ನೈಸರ್ಗಿಕ ಮತ್ತು ಕೃತ್ರಿಮ ರತ್ನಗಳು",
    "treatment_disclosure": "ಚಿಕಿತ್ಸೆ ಮತ್ತು ವರ್ಧನೆಯ ಬಹಿರಂಗಪಡಿಸುವಿಕೆ",
    "origin_significance": "ಮೂಲ ಮತ್ತು ಮೂಲದ ಮಹತ್ವ",

    // Wearing Guidelines
    "wearing_finger": "ಧರಿಸುವ ಬೆರಳಿನ ಮಾರ್ಗದರ್ಶನ",
    "wearing_day": "ಶುಭ ಧರಿಸುವ ದಿನ",
    "wearing_time": "ಸೂಕ್ತ ಧರಿಸುವ ಸಮಯ",
    "metal_selection": "ಸೆಟ್ಟಿಂಗ್‌ಗಾಗಿ ಲೋಹ ಆಯ್ಕೆ",
    "weight_calculation": "ರತ್ನ ತೂಕದ ಲೆಕ್ಕಾಚಾರ",
    "purification_ritual": "ಶುದ್ಧೀಕರಣ ಮತ್ತು ಸಕ್ರಿಯಗೊಳಿಸುವ ಆಚರಣೆ",

    // Gemstone Care
    "cleaning_methods": "ಶುಚಿಗೊಳಿಸುವ ಮತ್ತು ನಿರ್ವಹಣೆ ವಿಧಾನಗಳು",
    "storage_guidelines": "ಸರಿಯಾದ ಸಂಗ್ರಹಣೆ ಮಾರ್ಗಸೂಚಿಗಳು",
    "energizing_techniques": "ಮರು-ಶಕ್ತಿಯುತಗೊಳಿಸುವ ತಂತ್ರಗಳು",
    "avoid_damage": "ಹಾನಿ ತಡೆಗಟ್ಟುವ ಸಲಹೆಗಳು",
    "periodic_cleansing": "ಆವರ್ತಕ ಶುದ್ಧೀಕರಣ ಆಚರಣೆಗಳು",
    "replacement_timing": "ಬದಲಿ ಮತ್ತು ಅಪ್‌ಗ್ರೇಡ್ ಸಮಯ",

    // Benefits & Effects
    "career_benefits": "ವೃತ್ತಿ ಮತ್ತು ವ್ಯಾಪಾರ ಪ್ರಯೋಜನಗಳು",
    "health_benefits": "ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ ಪ್ರಯೋಜನಗಳು",
    "relationship_benefits": "ಸಂಬಂಧ ಮತ್ತು ಪ್ರೀತಿ ಪ್ರಯೋಜನಗಳು",
    "financial_benefits": "ಹಣಕಾಸು ಮತ್ತು ಸಮೃದ್ಧಿ ಪ್ರಯೋಜನಗಳು",
    "spiritual_benefits": "ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆ ಪ್ರಯೋಜನಗಳು",
    "protection_benefits": "ರಕ್ಷಣೆ ಮತ್ತು ಸುರಕ್ಷತೆ ಪ್ರಯೋಜನಗಳು",

    // Timing & Muhurat
    "auspicious_timing": "ಶುಭ ಖರೀದಿ ಸಮಯ",
    "wearing_muhurat": "ಧರಿಸುವ ಮುಹೂರ್ತ ಲೆಕ್ಕಾಚಾರ",
    "activation_timing": "ಸಕ್ರಿಯಗೊಳಿಸುವ ಆಚರಣೆ ಸಮಯ",
    "eclipse_precautions": "ಗ್ರಹಣ ಅವಧಿಯ ಮುನ್ನೆಚ್ಚರಿಕೆಗಳು",
    "festival_significance": "ಹಬ್ಬ ಮತ್ತು ವಿಶೇಷ ದಿನಗಳ ಮಹತ್ವ",
    "monthly_guidelines": "ಮಾಸಿಕ ಧರಿಸುವ ಮಾರ್ಗಸೂಚಿಗಳು",

    // Combination Guidelines
    "gemstone_combinations": "ಪ್ರಯೋಜನಕಾರಿ ರತ್ನ ಸಂಯೋಜನೆಗಳು",
    "conflicting_stones": "ಸಂಘರ್ಷದ ರತ್ನ ಸಂಯೋಜನೆಗಳು",
    "layered_wearing": "ಪದರದ ಧರಿಸುವ ಮಾರ್ಗಸೂಚಿಗಳು",
    "rotation_schedule": "ರತ್ನ ತಿರುಗುವ ವೇಳಾಪಟ್ಟಿ",
    "seasonal_preferences": "ಋತುಮಾನದ ರತ್ನ ಆದ್ಯತೆಗಳು",
    "occasion_selection": "ಸಂದರ್ಭದ ಆಧಾರದ ಮೇಲೆ ಆಯ್ಕೆ",

    // Alternative Options
    "budget_alternatives": "ಬಜೆಟ್-ಸ್ನೇಹಿ ಪರ್ಯಾಯಗಳು",
    "substitute_stones": "ಬದಲಿ ರತ್ನ ಆಯ್ಕೆಗಳು",
    "semi_precious_options": "ಅರೆ-ಮೌಲ್ಯಯುತ ಪರ್ಯಾಯಗಳು",
    "synthetic_alternatives": "ಕೃತ್ರಿಮ ರತ್ನ ಪರ್ಯಾಯಗಳು",
    "crystal_alternatives": "ಸ್ಫಟಿಕ ಮತ್ತು ಖನಿಜ ಪರ್ಯಾಯಗಳು",
    "rudraksha_combinations": "ರುದ್ರಾಕ್ಷ ಸಂಯೋಜನೆಗಳು",

    // Special Categories
    "bridal_gemstones": "ವಧುವಿನ ರತ್ನ ಆಯ್ಕೆ",
    "childrens_gemstones": "ಮಕ್ಕಳ ರತ್ನ ಮಾರ್ಗಸೂಚಿಗಳು",
    "elderly_recommendations": "ವಯಸ್ಸಾದವರಿಗೆ ನಿರ್ದಿಷ್ಟ ಶಿಫಾರಸುಗಳು",
    "professional_stones": "ವೃತ್ತಿಪರ ಮತ್ತು ವೃತ್ತಿ ರತ್ನಗಳು",
    "students_gemstones": "ವಿದ್ಯಾರ್ಥಿ ಮತ್ತು ಶೈಕ್ಷಣಿಕ ರತ್ನಗಳು",
    "artists_stones": "ಸೃಜನಾತ್ಮಕ ಮತ್ತು ಕಲಾತ್ಮಕ ರತ್ನಗಳು",

    // Astrological Factors
    "ascendant_stones": "ಲಗ್ನ ಆಧಾರಿತ ರತ್ನ ಆಯ್ಕೆ",
    "moon_sign_stones": "ಚಂದ್ರ ರಾಶಿ ರತ್ನ ಮಾರ್ಗದರ್ಶನ",
    "sun_sign_influence": "ಸೂರ್ಯ ರಾಶಿ ಆಯ್ಕೆಯ ಮೇಲಿನ ಪ್ರಭಾವ",
    "navamsa_considerations": "ನವಾಂಶ ಚಾರ್ಟ್ ಪರಿಗಣನೆಗಳು",
    "dasha_period_stones": "ದಶಾ ಅವಧಿ ನಿರ್ದಿಷ್ಟ ರತ್ನಗಳು",
    "transit_considerations": "ಪ್ರಸ್ತುತ ಸಂಕ್ರಮಣ ಪರಿಗಣನೆಗಳು",

    // Consultation Features
    "expert_consultation": "ತಜ್ಞ ರತ್ನಶಾಸ್ತ್ರಜ್ಞ ಸಮಾಲೋಚನೆ",
    "follow_up_guidance": "ಫಾಲೋ-ಅಪ್ ಮಾರ್ಗದರ್ಶನ ಲಭ್ಯ",
    "customization_options": "ಕಸ್ಟಮೈಸೇಶನ್ ಮತ್ತು ವೈಯಕ್ತೀಕರಣ",
    "update_recommendations": "ನವೀಕರಿಸಿದ ಶಿಫಾರಸುಗಳು",
    "progress_tracking": "ಪ್ರಯೋಜನಗಳ ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್",
    "adjustment_guidance": "ಹೊಂದಾಣಿಕೆ ಮತ್ತು ಫೈನ್-ಟ್ಯೂನಿಂಗ್",

    // Regional Preferences
    "indian_gemstones": "ಭಾರತೀಯ ಮೂಲದ ರತ್ನಗಳು",
    "burmese_stones": "ಬರ್ಮೀಸ್ ಮೂಲದ ರತ್ನಗಳು",
    "ceylon_sapphires": "ಸಿಲೋನ್ ರತ್ನ ವಿಶೇಷತೆ",
    "kashmir_sapphires": "ಕಾಶ್ಮೀರ ರತ್ನ ಪ್ರೀಮಿಯಂ",
    "colombian_emeralds": "ಕೊಲಂಬಿಯನ್ ಪಚ್ಚೆ ಉತ್ಕೃಷ್ಟತೆ",
    "african_gemstones": "ಆಫ್ರಿಕನ್ ಮೂಲದ ರತ್ನಗಳು",

    // Modern Applications
    "technology_enhancement": "ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ಡಿಜಿಟಲ್ ಜೀವನ ವರ್ಧನೆ",
    "stress_relief": "ಆಧುನಿಕ ಒತ್ತಡ ಪರಿಹಾರ ಪರಿಹಾರಗಳು",
    "urban_living": "ನಗರ ಜೀವನ ರತ್ನ ಅಗತ್ಯತೆಗಳು",
    "travel_protection": "ಪ್ರಯಾಣ ಮತ್ತು ಯಾತ್ರೆ ರಕ್ಷಣೆ",
    "workspace_harmony": "ಕೆಲಸದ ಸ್ಥಳದ ಸಾಮರಸ್ಯ ರತ್ನಗಳು",
    "social_confidence": "ಸಾಮಾಜಿಕ ಆತ್ಮವಿಶ್ವಾಸ ಬೂಸ್ಟರ್‌ಗಳು"
};
